import { createReducer } from '../../../utilities';
import {
    SUCCESS_FETCH_STATS_MATCHES_GOALS
} from "../../../../actions/entities/statistics/matches";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        ...data,
    };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_STATS_MATCHES_GOALS]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/matches/goals.js